export const selectData = (state) => state.billing.paymentMethods.data;
export const selectError = (state) => state.billing.paymentMethods.error;
export const selectLoading = (state) => state.billing.paymentMethods.loading;
